import { render, staticRenderFns } from "./ComplexExplanations.vue?vue&type=template&id=0dbcdae1&"
import script from "./ComplexExplanations.vue?vue&type=script&lang=js&"
export * from "./ComplexExplanations.vue?vue&type=script&lang=js&"
import style0 from "./ComplexExplanations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports